module.exports = __webpack_public_path__ + "img/wiperx_05.7a5d1a52.jpg";